import React, { useEffect, useState } from "react";
import { Alert } from "@themesberg/react-bootstrap";

const APP_URL = typeof window !== "undefined" ? window.location.origin : "https://wekarecords.com";

const OfflineNotice = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return (
    <Alert variant={isOnline ? "info" : "warning"} className="mb-4">
      {isOnline
        ? `Connected · ${APP_URL}`
        : "Offline · Changes will sync when you reconnect."}
    </Alert>
  );
};

export default OfflineNotice;
